import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import MeetingModal from './MeetingModal';

const useStyles = makeStyles({
  root: {
    minWidth: 675,

    padding: 7
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontSize: 12,
    fontFamily: 'PT sans',
    color: '#00D0B8',
    FontWeight: 'bolder',
    border: '1px solid #00D0B8',
    borderRadius: 11,
    padding: '0 9px'
  },
  status: {
    marginBottom: 12,
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#A7AAAE'
  },
  time: {
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#252523'
  },
  text: {
    marginTop: 15,
    fontFamily: 'PT sans',
    fontSize: '16px'
  },
  detail: {
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#A7AAAE',
    cursor: 'pointer'
  },
  message: {
    marginTop: 10,
    fontWeight: '600'
  },
  meet: {
    color: '#002380',
    fontWeight: 'bold'
  }
});

const MeetingCard = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const classes = useStyles();

  return (
    <>
      <MeetingModal onClose={() => setModalOpen(false)} open={modalOpen} />
      <Card className={classes.root} elevation={0}>
        <CardContent>
          <div className={classes.container}>
            <Typography className={classes.title} gutterBottom>
              Meeting
            </Typography>
            <Typography className={classes.time} gutterBottom>
              March 5, 10:34 AM
            </Typography>
          </div>
          <Typography className={classes.text}>
            <span className={classes.message}>
              You have an upcoming meeting
            </span>{' '}
            with <span className={classes.meet}>Blackrock</span> at 11:30 AM
          </Typography>
          <Typography
            className={classes.detail}
            onClick={() => setModalOpen(true)}>
            See detailed schedule
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};

export default MeetingCard;
